<template>
  <v-main>
    <CustomersTable />
  </v-main>
</template>

<script>
import CustomersTable from './CustomersTable'

export default {
  name: "CustomersTableContent",
  components: {CustomersTable}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/CustomersTableContent.vue